import React, { useState, useEffect } from "react";
import moment from "moment";
import { MODULE_API } from "../../../apis";
import DEATH_API from "../../../apis/death.api";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import linkedIcon from "../../../assets/images/DeathModuleNew/accountLink.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { Table,Tooltip } from "antd";
import "../LiabilityDashboard.css";
import { useSelector } from "react-redux";
export const LiabilityTable = (props) => {
  const history = useHistory();
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const Loancols = [
    {
      title: "Name of Credit ",
      dataIndex: "Nickname of Credit",
      key: "Nickname of Credit",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Owner",
      dataIndex: "Owner",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Bank",
      dataIndex: "Name of Issuer",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Last Four of Account No.",
      dataIndex: "Account Number",
      render: (record) => (record ? "****" + record : "N/A"),
    },
    {
      title: "Credit Limit",
      dataIndex: "Credit Limit",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Interest Rate(or APR%)",
      dataIndex: "Interest Rate (or APR%)",
      render: (record) => (record ? `${parseFloat(record).toFixed(2) + "%"} ` : "0.00%"),
    },
    {
      title: "Credit Balance",
      dataIndex: "Credit Balance",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              `$${parseFloat(record)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "$0"
          : "$0",
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{
                      //   opacity: record.managedBy === "Plaid" ? "0.3" : "1",
                      //   cursor:
                      //     record.managedBy === "Plaid"
                      //       ? "not-allowed"
                      //       : "pointer",
                      //   pointerEvents:
                      //     record.managedBy === "Plaid" ? "none" : "",
                      // }}
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}>
                      Update
                    </li>
                    <li
                      className="liHover"
                      // style={{
                      //   opacity: record.managedBy === "Plaid" ? "0.3" : "1",
                      //   cursor:
                      //     record.managedBy === "Plaid"
                      //       ? "not-allowed"
                      //       : "pointer",
                      //   pointerEvents:
                      //     record.managedBy === "Plaid" ? "none" : "",
                      // }}
                      onClick={() => {
                        deletePost(record.id, record.managedBy, record);
                        setDropdown(false);
                      }}>
                      Delete
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
            {/*record.managedBy === "Plaid" && (
            <div className="managed-by-plaid-icon"> </div>
            ) */}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            style={{
              cursor: "pointer",
              width: "18px",
              height: "18px",
            }}
            src={linkedIcon}
            alt="linkedIcon"
          ></img>
        </div>
      ),
      render: (record) => {
        return (
          <div style={{ display: "flex", minHeight: "40px",cursor:"pointer" }}>
            {record.managedBy === "Plaid" && (
              <Tooltip title="This icon indicates that the account is securely linked with our trusted financial data provider, allowing for real-time balance updates and transaction synchronization. The connection enables seamless financial tracking without manual entry.">
                <div className="managed-by-plaid-icon"> </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deleteLinkTransactions = async (id, record) => {
   await swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete ${
        record["Nickname of Credit"] ? record["Nickname of Credit"] : "Credit"
      } ? All Transactions in Budget will be deleted as well.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          let payload = {
            cmId: id,
          };
          const resposnse = await DEATH_API.deleteLinkTransactions(payload);
          if (resposnse && resposnse.status === 200) {
            swal("Success", resposnse.message, "success");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Transactions are safe :)", "error");
      }
    });
  };
  const deletePost = async (id, managedBy, recordToDelete) => {
    console.log("delete is", id);
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          if (managedBy === "Plaid") {
            await deleteLinkTransactions(id, recordToDelete);
          }
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          // setLiabilitesCredit([]);
          // setCreditRows([]);
          // if (res && res.status === 200 && managedBy === "Plaid") {
          //   deleteLinkTransactions(id, recordToDelete);
          // }
          setLoading(false);
          props.updateSharedState(!props.sharedState);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };

  const fnEdit = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}`
    );
  };
  const fnView = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}/view`
    );
  };
  const refresh = async () => {
    await props.refreshModule();
    props.updateSharedState(!props.sharedState);
  };
  const upgrade = () => {
    history.push("/payment");
  };
  const handleButtonClick = () => {
    swal({
      title: "Please Upgrade for complete experience",
      text: "Your level of subscription only allows Refresh of non-linked Assets.",
      icon: "warning",
      type: "warning",
      buttons: {
        upgrade: {
          text: "Upgrade",
          value: "upgrade",
          visible: true,
        },
        ok: {
          text: "Ok",
          value: "ok",
          visible: true,
        },
        cancel: {
          text: "Cancel",
          value: "cancel",
          visible: true,
          closeModal: true,
        },
      },
    }).then((value) => {
      console.log("Button value clicked:", value); // Debugging line to show the value
      switch (value) {
        case "upgrade":
          console.log("calling upgrade");
          upgrade();
          break;

        case "ok":
          console.log("calling Simple");
          refresh();
          break;

        case "cancel":
          console.log("Cancel button clicked");
          // Add your cancel logic here, if needed
          break;

        default:
          console.log("No action taken");
          break;
      }
    });
  };

  return (
    <React.Fragment>
      <div className="liablityInfoMaincard" style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}>
          <h3 className="liablitycardheading">
            Credit Line (Bank or Credit Card)
          </h3>
          {userRole && (userRole !== "FreeTrail" && userRole!=="Financial Advisor Client") && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: "1rem",
                color: "black",
              }}>
              <button
                className="addbuttonLiablity"
                style={{ paddingInline: "1rem" }}
                onClick={() => {
                  refresh();
                  // handleButtonClick();
                }}>
                {" "}
                Refresh
              </button>
              {refreshTime &&
                `Updated at: ${moment(refreshTime)
                  .local()
                  .format("MM/DD/YYYY [at] hh:mmA")}`}
            </div>
          )}
        </div>
        {/* <List cols={Loancols} rows={props.creditRows && props.creditRows} /> */}
        <Table
          columns={Loancols}
          dataSource={props.creditRows && props.creditRows}
          pagination={{
            total: props.totalPages * 10, // Assuming 10 items per page
            current: props.currentPage,
            onChange: (page) => {
              props.setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
        <NewLoader isLoading={props.loading || loading} />
      </div>
    </React.Fragment>
  );
};
